<template>
  <div class="graciasConsulta">
    <img
      width="130"
      class="success"
      alt="MODO"
      src="../assets/img/success.svg"
    />
    <h2>{{ textos[$route.params.tipoGracias].titulo }}</h2>
    <p class="texto" v-html="textos[$route.params.tipoGracias].texto" />
  </div>
</template>
<script>
export default {
  data() {
    const textos = {
      consulta: {
        titulo: "Tu consulta fue enviada con éxito",
        texto: `Te enviamos un email a <strong>${this.$route.params.email}</strong> con el detalle de tu consulta`
      },
      denuncia: {
        titulo: "Tu denuncia fue enviada correctamente",
        texto: `Te enviamos un email a <strong>${this.$route.params.email}</strong> con el detalle de tu denuncia`
      },
      feedback: {
        titulo: `¡Gracias ${this.$route.params.nombre}!`,
        texto:
          "Valoramos tu opinión y la vamos a tener en cuenta para mejorar cada día más."
      },
      consultaRecibida: {
        titulo: "Recibimos tu consulta",
        texto: `Te enviamos la confirmación de recepción a <strong>${this.$route.params.email}</strong>.`
      }
    };
    return { textos };
  }
};
</script>
<style scoped>
.graciasConsulta {
  padding-top: 30px;
  max-width: 490px;
}
h2 {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  margin-top: 0;
  font-size: 30px;
  line-height: 40px;
}
.texto {
  margin-top: 0;
  font-family: "BentonSansBBVA-Book", Helvetica, Arial, sans-serif;
  font-size: 16px;
  line-height: 24px;
}
</style>
